import * as go from 'gojs';

import { LinkCategory } from 'src/containers/ProjectDiagram/constants/categories';
import { RelationshipDirection } from 'src/containers/ProjectDiagram/constants/modelConcept';
import {
  ModelConceptRelationship,
  ModelConceptRelationshipLabel,
} from 'src/containers/ProjectDiagram/types/data';
import {
  Diagram,
  ModelConceptRelationshipLink,
} from 'src/containers/ProjectDiagram/types/diagram';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { isLink } from 'src/containers/ProjectDiagram/utils/graphObject';
import { addModelConceptRelationship } from 'src/containers/ProjectDiagram/utils/modelConceptRelationship/addModelConceptRelationship';
import { changeModelConceptRelationshipConnection } from 'src/containers/ProjectDiagram/utils/modelConceptRelationship/changeModelConceptRelationshipConnection';
import {
  addProjectModelIdsToIri,
  getProjectModelIdsForIri,
} from 'src/containers/ProjectDiagram/utils/projectModelIds';

export const addDomainOrRangeToRelationship =
  ({
    direction,
    relationshipIri,
    classIri,
    copyModelIds = false,
    useAllValidLinks = false,
  }: {
    classIri: string;
    direction: RelationshipDirection;
    relationshipIri: string;
    copyModelIds?: boolean;
    useAllValidLinks?: boolean;
  }) =>
  (model: Model, diagram: Diagram) => {
    const isOutgoing = direction === RelationshipDirection.OUTGOING;
    const validLinks = new go.Set<ModelConceptRelationshipLink>(
      (useAllValidLinks ? diagram.links : diagram.selection).filter(
        (part) =>
          isLink<ModelConceptRelationshipLink>(
            part,
            LinkCategory.MODEL_CONCEPT_RELATIONSHIP
          ) &&
          part.data.value === relationshipIri &&
          (isOutgoing ? !part.data.from : !part.data.to)
      ) as go.Iterator<ModelConceptRelationshipLink>
    );

    const reconnectedRelationships: ModelConceptRelationship[] = [];
    const reconnectedRelationshipLabels: ModelConceptRelationshipLabel[] = [];
    if (validLinks.size) {
      validLinks.each((link) => {
        const { linkData, linkLabelData } =
          changeModelConceptRelationshipConnection({
            key: link.data.key,
            fromIri: isOutgoing ? classIri : link.fromNode?.data.value,
            toIri: isOutgoing ? link.toNode?.data.value : classIri,
          })(model);
        if (linkData) {
          reconnectedRelationships.push(linkData);
        }
        if (linkLabelData) {
          reconnectedRelationshipLabels.push(linkLabelData);
        }
      });
    }

    const { addedRelationships, addedRelationshipLabels } =
      addModelConceptRelationship({
        direction,
        iri: relationshipIri,
        classIri,
        addUnconnectedRelationship: !validLinks.size,
      })(model, diagram);

    if (copyModelIds) {
      addProjectModelIdsToIri(
        relationshipIri,
        getProjectModelIdsForIri(classIri, model)
      )(model);
    }

    return {
      addedRelationships,
      addedRelationshipLabels,
      reconnectedRelationships,
      reconnectedRelationshipLabels,
    };
  };
